import { createSelector } from 'reselect';

export const getPurchaseOrderSelector = state => state.phase.purchaseOrders.items;

const getPurchaseOrdersWithLabel =
  createSelector(
    getPurchaseOrderSelector,
    (items) => {
      const counter = {};
      return items.map((item) => {
        let label = item.number;
        if (!counter[item.kind]) counter[item.kind] = 0;
        if (!item.number && item.id >= 0) {
          counter[item.kind] += 1;
          label = `${item.kind} ${counter[item.kind]}`;
        }
        return { ...item, label, value: item.id >= 0 ? item.id : '' };
      });
    },
  );

export default getPurchaseOrdersWithLabel;



// WEBPACK FOOTER //
// ./client/app/selectors/purchaseOrderOptions.js